export default "__VITE_ASSET__7056fbfa__"